import _copyObject_default from "./_copyObject.js";
import keysIn_default from "./keysIn.js";

//#region ../../node_modules/lodash-es/_baseAssignIn.js
/**
* The base implementation of `_.assignIn` without support for multiple sources
* or `customizer` functions.
*
* @private
* @param {Object} object The destination object.
* @param {Object} source The source object.
* @returns {Object} Returns `object`.
*/
function baseAssignIn(object, source) {
	return object && _copyObject_default(source, keysIn_default(source), object);
}
var _baseAssignIn_default = baseAssignIn;

//#endregion
export { _baseAssignIn_default as default };
//# sourceMappingURL=_baseAssignIn.js.map